<template>
    <section>
        <h1>Conciliaciones</h1>
    </section>
</template>
<script>
    export default {
        setup () {
            return {}
            }

        }
</script>
<style scoped>
</style>
